/**
 * LLM 모델 설정 관리
 * 모델 변경이 필요할 때 이 파일만 수정하면 됩니다.
 */

export const MODEL_CONFIG = {
  // 기본 모델 (정확도+속도 균형, CAT 인증 대응)
  DEFAULT_MODEL: 'claude-sonnet-4-5-20250929',
  
  // Max Intelligence 모델 (동일)
  MAX_INTELLIGENCE_MODEL: 'claude-sonnet-4-5-20250929',
  
  // 모델 정보 (UI 표시용)
  MODELS: {
    'claude-haiku-4-5-20251001': { 
      name: 'Haiku 4.5', 
      tier: 'standard',
      description: '빠르고 효율적'
    },
    'claude-sonnet-4-5-20250929': { 
      name: 'Sonnet 4.5', 
      tier: 'max',
      description: '최고 성능'
    }
  }
};

/**
 * 현재 선택된 모델을 반환
 */
export const getCurrentModel = (isMaxIntelligence = false) => {
  return isMaxIntelligence ? MODEL_CONFIG.MAX_INTELLIGENCE_MODEL : MODEL_CONFIG.DEFAULT_MODEL;
};

/**
 * 모델 정보를 반환
 */
export const getModelInfo = (modelName) => {
  return MODEL_CONFIG.MODELS[modelName] || { name: 'Unknown', tier: 'unknown' };
}; 